module.exports = __webpack_public_path__ + "15b09607b0e044bb07216f9d5f06e461.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Carousel/images/7.jpg
// module id = ./src/components/Carousel/images/7.jpg
// module chunks = 0